import React from 'react'
import MultiSelectInput from '../MultiSelectInput'
import {useSelector} from 'react-redux'
import {selectBuildingsByActiveOrganization} from '../../reducers/selectors'
import PropTypes from 'prop-types'

function MultiBuildingSelector(props) {
  const buildingsInOrg = useSelector(selectBuildingsByActiveOrganization)

  const options = buildingsInOrg.map(b => ({
    label: b.displayName,
    value: b.id,
  }))

  return (
    <MultiSelectInput
      onChange={props.onChange}
      value={props.value}
      options={options}
      className={props.className}
      isDisabled={props.isDisabled}
    />
  )
}

MultiBuildingSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array.isRequired, // array of building IDs
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
}

export default MultiBuildingSelector
